import { render, staticRenderFns } from "./AuditRegister.vue?vue&type=template&id=bdd6fd60&scoped=true"
import script from "./AuditRegister.vue?vue&type=script&lang=js"
export * from "./AuditRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd6fd60",
  null
  
)

export default component.exports